<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-7.15,799.77l-0.26-0.27l-2.09-2.08v-9.85l2.35-2.35h15.3l2.35,2.35v9.85l-2.35,2.35H-7.15z M-6.4,797.95H7.4l1.29-1.28
	v-8.34l-1.29-1.28H-6.39l-1.29,1.28v8.34L-6.4,797.95z M-4.84,796.78l-1.29-1.29l2.99-2.99l-2.99-2.99l1.29-1.28l4.28,4.28
	L-4.84,796.78z M2.38,796.46l-2.73-7.27l1.7-0.64l2.73,7.27L2.38,796.46z M6.02,796.46l-2.73-7.27l1.7-0.64l2.73,7.27L6.02,796.46z"
	/>
</svg>

</template>